<template>
  <div>
    <div class="card-page">
      <div class="card-info">
        <p class="info-card">Saldo GiroPos</p>
        <form>
          <select v-model="selectedGiro">
            <option value="1">IDR </option>
            <option value="2">USD </option>
          </select>
        </form>
        <span class="value-card" :class="{ active: selectedGiro == 1 }">{{ saldo.giropos_balance.toLocaleString("id") }}</span>
        <span class="value-card" :class="{ active: selectedGiro == 2 }">{{ saldo.giropos_usd_blance.toLocaleString("en-US") }}</span>
      </div>
      <div class="card-info">
        <p class="info-card">Saldo RDK</p>
        <form>
          <select v-model="selectedRdk">
            <option value="1">IDR </option>
            <option value="2">USD </option>
          </select>
        </form>
        <span class="value-card" :class="{ active: selectedRdk == 1 }">{{ saldo.rdk_balance.toLocaleString("id") }}</span>
        <span class="value-card" :class="{ active: selectedRdk == 2 }">{{ saldo.usd_balance.toLocaleString("en-US") }}</span>
      </div>
      <div class="card-info">
        <p class="info-card">Saldo Emas</p>
        <form>
          <select v-model="selectedEmas">
            <option value="1">IDR </option>
            <option value="2">USD </option>
          </select>
        </form>
        <span class="value-card" :class="{ active: selectedEmas == 1 }">{{ emas.toLocaleString("id") }}</span>
        <span class="value-card" :class="{ active: selectedEmas == 2 }">{{ emasUsd.toLocaleString("en-US") }}</span>
      </div>
    </div>
    <div class="content">
      <div class="riwayat">
        <p class="title">Riwayat 10 transaksi terakhir Jual Beli Emas</p>
        <table class="table">
          <tr>
            <th>No</th>
            <th>Tanggal</th>
            <th>Keterangan</th>
            <th>Jumlah</th>
            <th>Tipe</th>
          </tr>
          <tr v-for="(data, i) in riwayatTransaksi.slice(0, 10)" :key="i">
            <td>{{ i + 1 }}</td>
            <td>{{ data.attributes.createdAt | formatDate }}</td>
            <td>
              <span v-if="data.attributes.contractId === 1">100 gr</span>
              <span v-else-if="data.attributes.contractId === 2">10 oz</span>
              <span v-else-if="data.attributes.contractId === 3">1 kg</span>
              <span v-else-if="data.attributes.contractId === 4">10 kg</span>
              <span v-else-if="data.attributes.contractId === 5">0.01 gr</span>
              <span v-else-if="data.attributes.contractId === 6">KAU 1 gr</span>
              <span v-else>---</span>
            </td>
            <td>{{ data.attributes.settlementAmount }}</td>
            <td>
              <span v-if="data.attributes.direction === 'buy'"> Beli</span>
              <span v-else> Jual</span>
            </td>
          </tr>
        </table>
      </div>
      <!-- <div class="statistic">
              <p class="title">statistics</p>
              <line-chart :chart-data="dataColection" />
          </div> -->
    </div>
  </div>
</template>

<script>
// import LineChart from '../assets/LineChart'
// import { Line } from 'vue-chartjs'

import axios from "axios";
export default {
  // extends: Line,
  components: {
    // LineChart
  },
  data() {
    return {
      dataColection: null,
      saldo: "",
      emas: "",
      emasUsd: "",
      selectedGiro: 1,
      selectedRdk: 1,
      selectedEmas: 1,
      riwayatTransaksi: [],
    };
  },
  mounted() {
    this.fillData();
    // console.log(this.selectedRdk)
    axios.get("/v1/user/gold_saving").then((res) => {
      let micro = res.data.data.micro_balance_idr + res.data.data.premium_balance_idr;
      let microUsd = res.data.data.micro_balance_usd + res.data.data.premium_balance_usd;
      // this.saldo = res.data.data
      // console.log(microUsd)
      this.emasUsd = microUsd;
      this.emas = micro;
      // console.log(this.emas)
    });

    axios.get("/v1/user/posgo_balance").then((res) => {
      this.saldo = res.data.data;
    });

    axios.get("/v1/abx/transactions").then((res) => {
      this.riwayatTransaksi = res.data.data;
    });
  },
  methods: {
    fillData() {
      this.dataColection = {
        labels: ["1", "2", "3", "4", "5"],
        datasets: [
          {
            data: ["1", "2", "3", "4", "5"],
            options: { legend: { display: false } },
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.card-page {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.card-info {
  width: 330px;
  height: 133px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-top: 35px;
}

.info-card {
  font-size: 15px;
  color: #43425d;
}
form {
  display: inline-block;
  width: 75px;
  height: 40px;
  border-radius: 5px;
  font-size: 13px;
}

.content {
  margin-top: 73px;
  display: flex;
  justify-content: space-between;
}

select {
  width: 100%;
}

table {
  font-size: 13px;
}

.value-card {
  font-size: 25px;
  font-weight: bold;
  color: #4d4f5c;
  margin-left: 20px;
  display: none;
}
.active {
  display: inline-block;
}

.title {
  font-size: 18px;
  color: #4d4f5c;
}

.riwayat {
  /* flex: 1; */
  width: 48%;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.04);
  padding: 20px;
}

.statistic {
  width: 48%;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.04);
  padding: 20px;
}

@media (min-width: 768px) and (max-width: 1023px) {
  .riwayat {
    width: 100%;
  }
}
</style>
